import {
  connect,
} from 'react-redux';
import {
  withRouter,
} from '@vroskus/library-navigation';

import {
  actions as mainActions,
} from '../../../redux/modules/main';
import {
  actions as authActions,
} from '../../../redux/modules/auth';

import MainView from './MainView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './MainView';

const mapStateToProps = (): $StateProps => Object.freeze({
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  getRegions: () => dispatchAction(
    mainActions.getRegions(),
  ),
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
  setAuthUser: (params) => dispatchAction(
    authActions.setAuthUser(params),
  ),
  setupAuthentication: () => dispatchAction(
    authActions.setupAuthentication(),
  ),
  setupLanguage: () => dispatchAction(
    mainActions.setupLanguage(),
  ),
  setupRegion: () => dispatchAction(
    mainActions.setupRegion(),
  ),
  setupUser: (params) => dispatchAction(
    mainActions.setupUser(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(MainView);

const RoutedComponent = withRouter(ConnectedComponent);

const Component = RoutedComponent;

export default Component;
